import type { SagaIterator } from 'redux-saga';
import type { Action } from 'redux-actions';
import type {
  PapiRequestDaSharedGallectionFoldersUpdate,
  PapiGallection,
  PapiDeviation,
} from '@wix/da-papi-types';
import { requestNapi } from '@wix/da-http-client';
import { put, call, select } from 'redux-saga/effects';
import { putEntities } from '../../redux/entities/actions';
import type { SetGallectionCoverPayload } from '../actions';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { getGallectionType } from '../helpers';
import {
  normalizeDeviation,
  normalizeGallection,
} from '../../redux/normalizr/helpers';
import { getGrusername } from '../selectors';

export type Params = {
  gallection: PapiGallection;
  deviation: PapiDeviation;
  onlyIfMissing?: boolean;
};

function* setGallectionCover({
  gallection,
  deviation,
  onlyIfMissing = false,
}: Params) {
  if (onlyIfMissing && gallection.thumb) {
    return;
  }
  // stash doesn't support custom covers
  if (gallection.type === 'stash') {
    return;
  }
  if (
    ![DeviationTypes.IMAGE, DeviationTypes.LITERATURE].includes(
      getDeviationType(deviation)
    )
  ) {
    // Only allow images and literature deviations as gallection covers
    return;
  }

  const updatedGallection: PapiGallection = {
    ...gallection,
    thumb: deviation,
  };

  const entities = normalizeGallection(updatedGallection);

  yield put(putEntities({ entities }));

  const username: ReturnType<typeof getGrusername> = yield select(
    getGrusername
  );

  const params: PapiRequestDaSharedGallectionFoldersUpdate = {
    username,
    type: getGallectionType(gallection) ?? 'collection',
    folderid: gallection.folderId,
    name: gallection.name,
    cover_deviationid: deviation.deviationId,
  };

  yield call(
    requestNapi,
    {
      method: 'post',
      url: 'gallection/folders/update',
      data: params,
    },
    undefined
  );
}

export function* setGallectionCoverActionHandler(
  action: Action<SetGallectionCoverPayload>
): SagaIterator {
  const { gallection, deviation } = action.payload;

  yield call(setGallectionCover, {
    gallection,
    deviation,
  });

  // TODO: this should not be needed...
  const entities = normalizeDeviation(deviation);

  yield put(putEntities({ entities }));
}

export default setGallectionCover;
